<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="residue">
<h1>Residue</h1>
<p style="text-indent:0em !important">I still find you in coffee sips,</p>
<p style="text-indent:0em !important">burnt caramel smells</p>
<p style="text-indent:0em !important">and wool cardigans.</p>
<p style="text-indent:0em !important">I still find you in midnight drives,</p>
<p style="text-indent:0em !important">morning runs</p>
<p style="text-indent:0em !important">and midday sadness.</p>
<p style="text-indent:0em !important">I still find you in the middle of the night</p>
<p style="text-indent:0em !important">between twisted sheets</p>
<p style="text-indent:0em !important">as my fingers chase your shadow on the wall.</p>
<p style="text-indent:0em !important">You’re an echo bouncing across the room,</p>
<p style="text-indent:0em !important">a laugh that still sounds just as loud</p>
<p style="text-indent:0em !important">no matter how much I try to drown it out,</p>
<p style="text-indent:0em !important">a smile that takes the shape of everything</p>
<p style="text-indent:0em !important">I dare to look at.</p>
<p style="text-indent:0em !important">I still find you everywhere you’re not</p>
<p style="text-indent:0em !important">supposed to be,</p>
<p style="text-indent:0em !important">in every corner of my mind that should be</p>
<p style="text-indent:0em !important">mine.</p>
<p style="text-indent:0em !important">And every time I remind it that</p>
<p style="text-indent:0em !important">you’re not here,</p>
<p style="text-indent:0em !important">my body screams</p>
<p style="text-indent:0em !important">as if you’ve just</p>
<p style="text-indent:0em !important">left</p>
<p style="text-indent:0em !important">all</p>
<p style="text-indent:0em !important">over</p>
<p style="text-indent:0em !important">again.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?2edf937a